import {
  AGGREGATOR_AVAILABLE_FEATURES_MAP,
  AGGREGATOR_FEATURES_MAP,
  AGGREGATOR_TYPE,
  OUTLET_STATUSES,
  WEBHOOK_SOURCE_TYPE,
} from "../data/outlet-status-constants";
import * as ICONS from "../assets/icons";
import { OUTLET_ONLINE_STATUS } from "../data/local-storage-constants";
import moment from "moment";
import store from "../redux/store";

export const isAggregatorFeatureAvailable = (
  featureType: string,
  aggregatorType: string,
  webhookSourceType: string = ""
) => {
  let availableFeaturesList = getAvailableFeaturesList(
    aggregatorType,
    webhookSourceType
  );
  return availableFeaturesList?.indexOf(featureType) !== -1;
};

export const getAggregatorLogo = (type: string) => {
  const logosMap: any = {
    dotpe: ICONS.ic_dotpe_logo,
    rista: ICONS.ic_dotpe_logo,
    zomatotrace: ICONS.ic_zomato_logo,
    zomato: ICONS.ic_zomato_logo,
    swiggy: ICONS.ic_swiggy_logo,
    urbanpiper: ICONS.ic_urbanpiper_logo,
    magicpin: ICONS.ic_magicpin_logo,
    webhook: ICONS.ic_webhook_logo,
  };
  if (type === "Dine In") {
    return ICONS.ic_dinein_logo;
  }
  let key = Object.keys(logosMap).find(function (key) {
    return type.toLowerCase().indexOf(key) > -1;
  });
  return (key && logosMap[key]) || ICONS.ic_webhook_logo;
};

/**
 * This function checks if the given aggregator has features other than 'activity_log',
 * 'outlet_status', 'outlet_toggle', 'refresh_cta'.
 * @param aggregatorType
 * @param webhookSourceType
 */
export const showOutletMenuIcon = (
  aggregatorType: string,
  webhookSourceType: string = ""
) => {
  let availableFeaturesList = getAvailableFeaturesList(
    aggregatorType,
    webhookSourceType
  );
  let excludedFeaturesList = [
    AGGREGATOR_FEATURES_MAP.activity_log.id,
    AGGREGATOR_FEATURES_MAP.outlet_status.id,
    AGGREGATOR_FEATURES_MAP.outlet_toggle.id,
    AGGREGATOR_FEATURES_MAP.refresh_cta.id,
    AGGREGATOR_FEATURES_MAP.health_hub_cta_payload.id,
  ];
  let showMenuIcon = false;
  availableFeaturesList?.forEach((feature: string) => {
    if (excludedFeaturesList.indexOf(feature) === -1) {
      showMenuIcon = true;
    }
  });
  return showMenuIcon;
};

export const getAvailableFeaturesList = (
  aggregatorType: string,
  webhookSourceType: string = ""
) => {
  if (aggregatorType !== AGGREGATOR_TYPE.webhook.id) {
    return AGGREGATOR_AVAILABLE_FEATURES_MAP[aggregatorType] || [];
  }
  if (
    webhookSourceType === WEBHOOK_SOURCE_TYPE.dotpe.id ||
    webhookSourceType === WEBHOOK_SOURCE_TYPE.dotpedelivery.id ||
    webhookSourceType === WEBHOOK_SOURCE_TYPE.dotpepickup.id ||
    webhookSourceType === WEBHOOK_SOURCE_TYPE["dotpedine-in"].id ||
    webhookSourceType === WEBHOOK_SOURCE_TYPE.magicpin.id ||
    webhookSourceType === WEBHOOK_SOURCE_TYPE.thrive.id
  ) {
    return AGGREGATOR_AVAILABLE_FEATURES_MAP.webhook_second_type;
  }
  return AGGREGATOR_AVAILABLE_FEATURES_MAP.webhook_first_type;
};

export const getSingleOutletOnlineStatus = (
  outletId: string,
  currentStatus: any = null,
  lastChecked: any = null
) => {
  if (!outletId) return {};
  let newData: any = {};
  if (currentStatus) {
    newData.currentStatus = currentStatus;
  }

  if (lastChecked) {
    newData.lastChecked = lastChecked;
  } else {
    newData.lastChecked = moment();
  }
  return newData;
};

export const getAllOutletOnlineStatus = (allOutletList: any) => {
  if (!allOutletList?.length) {
    return {};
  }
  let dataToUpdate: any = {};
  for (let outletObj of allOutletList) {
    let newData: any = {};
    let newStatus = outletObj?.outletStatus?.active;
    if (newStatus === OUTLET_STATUSES.ACTIVE) {
      newData.currentStatus = OUTLET_STATUSES.ONLINE;
    } else if (newStatus === OUTLET_STATUSES.INACTIVE) {
      newData.currentStatus = OUTLET_STATUSES.OFFLINE;
    } else newData.currentStatus = newStatus;
    if (outletObj?.lastModifiedOutletDate) {
      newData.lastChecked = outletObj?.lastModifiedOutletDate;
    } else {
      newData.lastChecked = moment();
    }
    dataToUpdate[outletObj?.id] = newData;
  }
  return dataToUpdate;
};

export function parseOutletOnlineStatus(
  data: Record<string, any>,
  type: string,
  webhookSourceType = ""
) {
  let statusKey = "active",
    outletCurrentStatus;
  if (type === AGGREGATOR_TYPE.zomato.id) {
    statusKey = "outlet_delivery_status";
  }
  if (Object.keys(data)?.length) {
    outletCurrentStatus = data?.[statusKey]
      ? OUTLET_STATUSES.ONLINE
      : OUTLET_STATUSES.OFFLINE;
  }

  if (type === "webhook" && webhookSourceType.toLowerCase().includes("dotpe")) {
    outletCurrentStatus =
      data.active === true ? OUTLET_STATUSES.ONLINE : OUTLET_STATUSES.OFFLINE;
  }
  return outletCurrentStatus;
}
